export const STRINGS = {
  //----------------------------ListScreen---------------------------------------
  LIST_HEAD: "list",
  LIST_TEXT: "Lists",
  //----------------------------PromptGenerationScreen-----------------------------
  PROMPT_HEADER: "New Prompt",
  PROMPT_LIST: "Prompts",
  PROMPT_LIST_VALUE: "2 files, 2 folders",
  PROMPT_BREADCRUMBS: "Prompts",
  //------------------------------SequenceForEMScreen-------------------------------
  SEQUENCE_HEAD: "sequences",
  SEQUENCE_LIST: "Sequences",
  TYPE_SEQ: "Sequences",
  SEQUENCE_LIST_VALUE: "120 lists,50 folders",
  //-------------------------------CampaignForEMScreen-------------------------------
  CAMPAIGN_HEAD: "campaign",
  CAMPAIGN_LIST: "Campaigns",
  CAMPAIGN_LIST_VALUE: "125 list, 2 folders",
  //--------------------------------Other Strings--------------------------------------
  LOADING: "Loading...",
  SEARCH_TEXT: "Search",
  MOVE_TO_BTN: "Move to",
  DELETE: "Delete",
  NEW_FOLDER: "Create Folder",
  NEW_PROMPT: "Create Prompt",
  NEW_SEQUENCE: "Create Sequence",
  PROMPT_TEMPLATE: "New Prompt",
  PROMPT_NAME: "Prompt Name*",
  PROMPT_NAME_PLACEHOLDER: "Enter prompt name",
  OWNER_BY: "Owner by",
  PROMPT_FOLDER: "Folder",
  SHARED_WITH: "Shared with*",
  PROMPT_DESC: "Prompt",
  PROMPT_CREATE_BTN: "Create Prompt",
  PROMPT_CANCEL_BTN: "Cancel",
  PRIVATE_LABEL: "Private",
  TEAM_LABEL: "My Team",
  PRIVATE_ID: "private",
  TEAM_ID: "team",
  TYPE_CAMP: "campaign",
  SMALL_FILE: "file",
  LISTID: "sequence_list",
  CREATE_SEQ: "Create Sequence",
  EDIT_SEQUENCE: "Edit Sequence",
  CLONE_SEQUENCE: "Clone Sequence",
  TYPESEQUENCE: "Enter sequence name",
  CANCEL: "Cancel",
  UPDATE: "Update",
  CREATE: "Create",
  CLONE: "Clone",
  DEFAULT: "default",
  CHOOSE_HEAD: "Choose Steps for Sequence Name",
  CHOOSE_STEPS_TEXT:
    "Sequences are a series of automated or manual touchpoints and activities, designed to drive deeper engagement with your prospects.",
  ADD: "Add",
  COMMON_PIN: "Pin",
  EDIT: "edit",
  UPDATE_CONTACT: "Update Contact",
  EDIT_CONTACTS: "Edit Contact",
  COMMON_EDIT: "Edit",
  DELETE_BULK: "Are you sure you want to delete the selected",
  DELETE_SELECTED: "Delete",
  SMALL_DELETE: "delete",
  AI_ASSISTANT: "Email Generation Assistant",
  CREDITS_AVAILABLE: "Credits Available:",
  IDENTIFY_YOUR:
    "Describe your ideal industry or industries, including relevant markets, typical stakeholders, and primary pain points.",
  OUTLINE_SOLUTIONS: "Key Message & Offer (What do you want to communicate?)",
  ADDRESS_FEATURES:
    "Define the core message of your campaign and highlight any offers or incentives.",
  CHALLENGE_PROMO:
    "Challenges Addressed (What are the key challenges you are addressing?)",
  CTA_PROMO: "Call To Action",
  DO_YOU_HAVE:
    "Explain the challenges your campaign addresses and how your solution benefits the audience.",
  ADD_INFO: "Call to Action (CTA)",
  FEEL_FREE:
    "Specify the desired action (e.g., sign up, purchase, learn more).",
  CREDITS: "Credits",
  AI_RESPONSE: "AI Response",
  PREVIEW: "Preview",
  SUBJECT2: "Subject:",
  GENERATING: "Generating",
  GET_THE_BEST:
    "Get the best AI-generated content to enhance your marketing campaigns.",
  INPUT_LEFT: "Input your details on the left to get started.",
  COPY_ANSWER: "Copy Answer",
  COPIED: "Copied",
  REGENERATE: "Regenerate",
  REQ_CRED: "Request Credits",
  ADD_TO: "Add to",
  GENERATE_RESPONSE: "Generate Response",
  DEFINE_TARGET: "Target Industry (Who is your campaign for?)",
  SERVICE_FOCUS: "Service Focus",
  SERVICE_FOCUS_TOOLTIP:
    "Select one or multiple services that this campaign relates to.",
  DESC_BOX: "Description",
  DESC_BOX_TOOLTIP:
    "Provide additional details specific to the selected service(s).",
  TONE_AND_STYLE: "Tone & Style",
  TONE_AND_STYLE_TOOLTIP:
    "Choose a tone (e.g., professional, friendly, persuasive) that aligns with your campaign goal.",
  ADDITIONAL_DETAILS: "Additional Details",
  ADDITIONAL_DETAILS_TOOLTIP:
    " Provide any extra information relevant to refining the generated prompt.",
  ADMIN_USER: "admin-user",
  SMALL_FOLDER: "folder",
  SAVED_CONTACTS: "Saved Contacts",
  FILE: "file",
  DISABLE_KEY: "operation",
  CREATE_LISST: "Create List",
  LIST_CONT: "Start creating your lists in order to manage your contacts",
  LIST_BD: "to whom you wish to reach out for business opportunities.",
  ID: "_id",
  TYPE_TEMP: "template",
  SEARCH_LIST: "Search List",
  MOVE_TO: "Move to",
  MOVE_TO_FOLDER: "Move to folder",
  SEARCH_FOLDER: "Search Folder",
  COMMON_CANCEL: "Cancel",
  MOVE: "Move",
  RM_FROM_FOLDER: "Remove from Folder",
  CREATE_LIST: "Create List",
  BULK_DEL_TYPE: "foldListDel",
  DEL: "del",
  LIST_REMT: "listRemove",
  COMMON_FOLDER: "Folder",
  UPDATE_LIST: "Edit List",
  LISTNAME: "Contact List Name*",
  TYPELIST: "Type Contact List name",
  ADD_STEP: "Save",
  PROMPT_UPDATE_BTN: "Update Prompt",
  STATISTICS: "STATISTICS",
  COMMON_CLONE: "Clone",

  // Campaign related strings
  // General text
  CAMPAIGNS_TEXT: "Campaigns",
  CAMPAIGN_TEXT: "Campaigns",
  SEARCH: "Search Campaign",
  SEARCH_DEVICES: "Search Devices",

  // Button labels
  CREATE_CAMPAIGN: "Create",
  CREATE_FOLDER: "Create Folder",

  // Actions and operations
  PIN: "pin",
  PAUSE: "Pause",
  RESUME: "Resume",
  // Types
  FOLDER: "Folder",
  INTERRUPTED: "interrupted",

  // Campaign creation content
  CRT_CMPGS: "Create Campaign",
  CMPGS_CONT: "Create campaigns to engage with your contacts",
  CMP_BD1: "Draft compelling emails with customizable templates",
  CMP_BD2: "Schedule sending based on your preferred timing",
  CMP_BD3: "Track opens, clicks, and responses for optimal engagement",

  // Campaign contacts
  CAMPAIGN_CONTACTS_ID: "campaign-contacts",

  // Additional identifiers
  STATS_DATA: "stats_data",
  ACTION: "action",
  MARKETING_LIST: "marketing_list",

  HEAD: "campaign_header",
  CAMPAIGN_DESCRIPTION: "Create a campaign in 4 easy steps.",
  AUTOMATED_CAMPAIGN_DESCRIPTION:
    "Create an automated campaign in 5 easy steps.",

  // Step indicators
  STEP1: "Step 1",
  STEP2: "Step 2",
  STEP3: "Step 3",
  STEP13: "1/4",
  STEP23: "2/3",
  STEP33: "3/3",

  // Basic details step
  CAMP_BASIC_DETAILS: "Campaign Basic Details",
  COMMON_NAME: "Name",
  ENTER_CAMP_NAME: "Enter campaign name",
  SENDVIA: "Send via",
  ESP: "esp_",
  CONNECT_GOOGLE: "Connect Google",
  CONNECT_OUTLOOK: "Connect Outlook",
  SEND_CAMPAIGN_WITH: "Send campaign with",
  SELECT_SIGNATURE: "Select signature",
  DEF_SIGNATURE: "Default Signature",

  // Sequence and list step
  SELECT_SEQ_LIST: "Select Sequence and List",
  SEQ_TOBE_USED: "Sequence to be used",
  LIST_TOBE_USED: "List to be used",

  // Skipped contacts step
  SKIPPED_CONTACTS: "Skipped Contacts",
  NO_CONTACT: "No contacts will be skipped",

  // Timing step
  TIMINGS: "Timings",
  TIMEZONE: "Timezone",
  SCHEDULE_DATE: "Schedule Date",
  RESET: "Reset",
  SAVE: "Save",

  // Preview step
  CAM_NAME: "Campaign Name",
  SENVIA: "Send Via",
  EMAIL: "Email",
  SEQUEN: "Sequence",
  LIS: "List",
  SKPCON: "Skipped Contacts",
  CONTACTS: "Contacts",
  CONTACT: "Contact",
  SCHDAT: "Schedule Date",
  TMZN: "Timezone",
  DY: "Day",

  // Button labels
  BACK: "Back",
  NEXT: "Next",
  START_CAMP: "Create Campaign Now",
  SCHEDULE_CAMPAIGN: "Schedule Campaign",

  // Image alt text
  SMALL_ACTIVE: "small active",
  SMALL_DONE: "small done",
  UNSEL: "unselected",

  // Misc
  COPYOF: "Copy of",
  CAMPAIGN_CONTACTS_CAMP: "contacts",

  CAMPAIGN_CONTACTS_LABEL: "Contacts",
  CAMPAIGN_OVERVIEW_LABEL: "Overview",
  CAMPAIGN_SETTINGS_LABEL: "Settings",
  TOTAL_ENROL: "total_enrolled",
  SENT: "Sent",
  DELIVER: "Delivered",
  BOUNCED: "Bounced",
  UNSUBSCRIBED: "Unsubscribed",
  COMPANY: "Company",
  COMMON_STEP: "Step",
  PROCESS_DATE_TIME: "processing_date_time",

  // Buttons and Actions
  SEARCH_CONTACTS: "Search Contacts",

  // Modals and Dialogs
  UNENROLL_CONFIRMATION: "Are you sure you want to unenroll this contact?",

  // Tabs and Navigation
  CAMPAIGN_OVERVIEW_ID: "campaign_overview",
  CAMPAIGN_ACTIVITY_ID: "campaign_activity",
  CAMPAIGN_SETTINGS_ID: "campaign_settings",

  // Miscellaneous
  NO_RECORD_FOUND: "No records found",
  START_CAMPAIGN: "Start Campaign",
  START_CAMPAIGN_AGAIN: "Start Campaign Again",
  AVAILABLE_DEVICES: "Free Devices",
  LIST_CREATE: "List",
  DELETE_CONFIRMATION: "Are you sure you want to Delete this",
  ADD_DEVICE: "Add Device",

  // Suppression related strings
  AI_LEADS: "Leads",
  AI_UNSUBSCRIBED: "Unsubscribed",
  AI_BLACKLISTED: "Failed Deliveries",
  AI_OUT_OF_OFFICE: "Out of Office",
  MANUAL_REVIEW: "Manual Review",
  NEW: "Unknown",
  JUNK: "Junk",
  ONE_PAGE_SLT: "1 contact on this page is selected",
  SELECT_ALL: "Select all",
  UNSELECT_ALL: "Unselect all",
  SMALL_CONTACTS: "contacts",
  ADD_CONTACTS: "Add Contact",
  ADD_LEADS: "Add Lead",
  ADD_CONTACTS_BULK: "Add Contacts",

  // VIEW MODAL STRINGS
  PEOPLE: "People",
  ALL_CONTACTS: "All Contacts",
  ALL_COMPANIES: "All Companies",
  ACTIVE_VIEW_ID: "active_view_id",
  VIEW_ID: "view-id",
  DELETE_VIEW: "View Deleted Successfully",
  PINNED_VIEW: "View Pinned Successfully",
  PIN_VIEW_TO_KEEP_OPEN: "Pin view to keep it open",
  EDIT_VIEW: "Edit this view",
  DELETE_THIS_VIEW: "Delete this view",
  ARE_YOU_SURE_DELETE: "Are you sure you want to Delete this View?",
  STANDARD: "Standard",
  PRIVATE_VIEW: "Private View",
  SHARED_VIEW: "Shared View",
  NO_PRIVATE_VIEW_CREATED: "No Private View Created!",
  NO_TEAM_VIEW_CREATED: "No Team View Created!",
  ME: "Me",
  HEADER_ID: "head",
  UNPIN_THIS_VIEW: "Unpin This View",
  ALL_CONTACT_SAVED_VIEWS: "Contact Saved Views",
  COMPANY_SAVED_VIEWS: "Company Saved Views",
  REQUIRED: "This is a required field.",
  VIEW_CANT_25CHAR: "View Name can't be more than 50 charecters.",
  CREATE_NEW_VIEW: "Create New View",
  VIEW_NAME: "View Name*",
  WRITE_VIEW_NAME: "Write view name",
  ERROR: "error",
  SHARED: "Shared with*",
  PIN_THIS_VIEW: "Pin This View",
  DATE_PICKER: "Date Picker",
  NUMBER: "Number",
  MULTI_LINE_TEXT_INPUT: "Multi-line Text Input",
  RICH_TEXT_EDITOR: "Rich Text Editor",
  MULTIPLE_CHECKBOX: "Multiple Checkbox",
  MULTIPLE_SELECT: "Multiple Select",
  SINGLE_SELECT: "Single Select",
  ENTER_FOLDER: "Enter Folder Name",
  ENTER_FOLDER_PLACEHOLDER: "Enter folder name",
  SMALL_CLONE: "clone",
  RE2: "Re:",
  SMALL_EDITOR: "editor",
  LISTID: "_name",
  AUTOMATED_EMAIL: "Automated email",
  SMALL_STEP: "step",
  INTERVALS: "Interval (in days)*",
  TEMPLATE: "Template",
  SUBJECT1: "Subject*",
  ENTER_SUBJECT: "Enter Subject",
  BODY: "Body",
  UPDATE: "Update",
  CLONE: "Clone",
  SAVE: "Save",
  CANCEL: "Cancel",
  SAVE_NEW_TEMPLATE: "Save as a new Template",
  TEMPLATE_NAME: "Template name:",
  SUBJECT_SMALL: "subject",
  SMALL_EDIT: "edit",
  SELECT_TEMPLATE: "Select Template",
};
